import React from "react";

export const initialContext = {
  inputsValidated: true,
  customerError: ""
}

export default React.createContext(initialContext);
